<ng-container *ngIf="actionMode">
  <div [ngSwitch]="actionMode">
    <ng-container *ngSwitchCase="ACTION_MODES.conversation">
      <a
        i18n="@@profileView.profileAction.anchorLabel.messageCta"
        mat-raised-button
        color="primary"
        [routerLink]="['/conversations', profile.conversationId]"
      >
        Message
      </a>
    </ng-container>
    <ng-container *ngSwitchCase="ACTION_MODES.introduction">
      <ng-container *ngIf="matchGroup?.document?.slug">
        <a
          mat-raised-button
          color="primary"
          [routerLink]="['/conversations', profile.conversationId]"
        >
          <span
            *ngIf="matchIsActioned"
            i18n="@@profileView.profileAction.anchorLabel.messageCta"
            >Message</span
          >
          <span
            *ngIf="!matchIsActioned"
            i18n="@@profileView.profileAction.anchorLabel.sayHelloCta"
            >Say hello 👋</span
          >
        </a>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="ACTION_MODES.manual">
      <ng-container [ngSwitch]="messageStatus">
        <div *ngSwitchCase="ProfileMessageStatus.none">
          <a
            i18n="@@profileView.profileAction.anchorLabel.sayHelloCta"
            mat-raised-button
            color="primary"
            [disabled]="isLoading"
            (click)="openMessageDialog(profile, user)"
          >
            Say hello 👋
          </a>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
